// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3rfXZ","content":"styles_content__3WUS4","selectAll":"styles_selectAll__6xLhi"};